<template>
  <vue-final-modal v-model="medleyLinkModalVisible" name="medley-link-dialog"
    :classes="['medley-link-dialog__container']"
    :styles="{ display: 'flex', alignItems: 'center', justifyContent: 'center' }"
    :content-class="['medley-link-dialog__content', 'v--modal-box', 'v--modal']"
    :click-to-close="true" :lock-scroll="true"
    @opened="onMedleyLinkModalOpened" @closed="onMedleyLinkModalClosed"
    @before-close="handleBeforeClose">
    <div style="text-align: left;">
      <p style="color: gray; border: 1px solid; display: inline;">PR</p>
    </div>
    <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
      <el-button @click="closeMedleyLinkDialog" icon="el-icon-circle-close" style="font-size: 2rem;"
        type="text"></el-button>
    </div>
    <div class="setting">
      <div class="setting-item" style="text-align:center;">
        <p style="font-size: 1rem; font-weight: bold;">ダウンロードが完了しました！！！</p>
        <p style="font-size: 1rem; font-weight: bold;">さっそく転職活動をスタートしましょう！<br>好条件求人満載のおすすめサイトはここ！</p>
        <div style="text-align:center; padding: 10px; margin-top: 10px;"
          :id="!$globalVar.googleAdsTagCheck(clientId, permissionType) ? 'pdf-' + $globalVar.dn_flag + '-rt-completed' : clientId + '_' + permissionType + '_btn'"
          @click="sendMedleyConsult()">
          <p style="display: inline-block;">
            <img :src="dialogInfo.logoImage" alt="">
          </p>
        </div>
        <p style="font-weight: bold;"><span style="color:red;">【重要】</span>ご同意頂いた方に、{{ dialogInfo.clientServiceName }}より<br>ご案内のメールを送付しますので、ご確認下さい。
        </p>
        <br>
        <p style="font-size: 80%;">
          Yagishの<router-link id="footer-link-terms" :to="{ name: 'termsPage' }"
            target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{ name: 'policyPage' }"
            target="_blank">個人情報保護方針</router-link>、<a href="https://www.yagish.jp/privacy_policy/"
            target="_blank">プライバシーポリシー</a><br />
          {{ dialogInfo.clientName }}の<a :href="dialogInfo.termurl" target="_blank">利用規約</a>、<a
            :href="dialogInfo.privacyurl" target="_blank">個人情報保護方針</a>を
          <br>確認して{{ dialogInfo.clientServiceName }}に登録することになります。
        </p>
        <p style="font-size: 1rem; font-weight: bold; margin-top: 10px;">
          <el-checkbox v-model="isAgree"
            style="-moz-transform:scale(1.4);-webkit-transform:scale(1.4);transform:scale(1.4);">各種規約に同意して無料登録する</el-checkbox>
        </p>
        <div class="text-center" style="padding:10px">
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed'" type="success"
            v-if="!isSendedMedley"
            style="background-color:#F60B26;border-color:#F60B26;font-size: 120%;"
            @click="sendMedleyConsult()">同意する</el-button>
          <el-button :id="'pdf-' + $globalVar.dn_flag + '-rt-completed-done'" type="success"
            v-else
            style="background-color:#0F9934;border-color:#0F9934;"
            @click="closeMedleyLinkDialog()">送信しました</el-button>
          <br />
        </div>
      </div>
    </div>
  </vue-final-modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script setup lang="ts">
import { useRtDialogBase } from '@/composables/useRtDialogBase'

const base = useRtDialogBase({
  openDialogEventName: 'open-medleylink-dialog',
  // MedleyLink は handler 自体は sendMedleyConsult を使うが、hub イベント名は
  // 'send-medleylink-consult' で名前空間を分けている（既存仕様維持）。
  primaryConsultEventName: 'send-medleylink-consult',
  primaryConsultHandlerKey: 'sendMedleyConsult',
  defaultPermissionType: 5,
  defaultClientId: 'medley_link',
  defaultDialogName: 'medley_dialog',
  afterApplyInfo: () => {
    base.isAgree.value = true
  }
})

// テンプレート互換のための別名（旧 API キーを維持）
const medleyLinkModalVisible = base.modalVisible
const isSendedMedley = base.isSended
const closeMedleyLinkDialog = base.closeDialog
const onMedleyLinkModalOpened = base.onModalOpened
const onMedleyLinkModalClosed = base.onModalClosed
const handleBeforeClose = base.handleBeforeClose
const fullscreenLoading = base.fullscreenLoading
const dialogInfo = base.dialogInfo
const clientId = base.clientId
const permissionType = base.permissionType
const isAgree = base.isAgree
const sendMedleyConsult = base.sendMedleyConsult
</script>

<style scoped lang="scss">
/* content-class は VueFinalModal 内部のノードのため scoped だけだと [data-v-*] が付かない → :deep() で子まで適用 */
:deep(.medley-link-dialog__container) {
  box-sizing: border-box;
  align-items: flex-start !important;
  overflow-y: auto;
  padding: 40px 0;
  -webkit-overflow-scrolling: touch;
}

:deep(.medley-link-dialog__content) {
  background: #fff;
  box-sizing: border-box;
  flex: 0 1 auto;
  align-self: center;
  width: 600px;
  max-width: 100%;
  height: auto;
  margin-top: auto;
  margin-bottom: auto;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: visible;
}
</style>
